import axiosInstance from "@/utils/axiosInstance";
import store from "@/store";

const baseUrl = `api/users`;

const state = {
  relays: undefined as any,

};

const getters = {
  relays: (state) => state.relays,

};

const mutations = {
  setRelays(state, relays) {
    state.relays = relays || null;
  },
};

const actions = {
  getLateKeys({ commit }, payload: { id: number }) {
    return axiosInstance.get(`${baseUrl}/${payload.id}/late-keys`, {
      params: { companyId: store.getters.envCompanyId },
    }).then((data) => data.data);
  },
  getKeysOutIn({ commit }, payload: { id: number, query: object }) {
    return axiosInstance.get(`${baseUrl}/${payload.id}/keys-out-and-in`, {
      params: payload.query,
    }).then((data) => data.data);
  },
  getMyKeys({ commit }, payload: { id: number, query: object }) {
    return axiosInstance.get(`${baseUrl}/${payload.id}/keys`, {
      params: {
        ...payload?.query, companyId: store.getters.envCompanyId,
      },
    }).then((data) => data.data);
  },
  getPayments({ commit }, payload: { userId: number, query: any }) {
    return axiosInstance.get(`${baseUrl}/${payload.userId}/payments`, { params: payload?.query })
      .then((data) => data.data);
  },
  getExistingByEmail({ commit }, payload: { email: string }) {
    return axiosInstance.get(`${baseUrl}/exist/email`, { params: {
      email: payload.email,
      companyId: store.getters.envCompanyId,
    }}).then((data) => data.data);
  },
  getUserById({ commit }, payload: { id: number }) {
    return axiosInstance.get(`${baseUrl}/${payload.id}`)
      .then((data) => data.data);
  },
  setCredentials({ commit }, payload: { email: string, password: string, userId: number }) {
    return axiosInstance.put(`${baseUrl}/${payload.userId}/credentials`, payload)
      .then((data) => data.data);
  },
  createGroup({ commit }, payload: { users: any, userGroupCreation: object }) {
    return axiosInstance.post(`${baseUrl}/group`, {
      users: payload.users.map((k: any) => k.id), userGroupCreation: payload.userGroupCreation,
    }).then((data) => data.data);
  },
  importUsers({ commit }, payload: { companyId: number, users: object, importType: string }) {
    return axiosInstance.post(`${baseUrl}/import`, {
      companyId: payload.companyId, users: payload.users, importType: payload.importType,
    })
      .then((data) => data.data);
  },
  updateUser({ commit }, payload: { id: number, user: object }) {
    return axiosInstance.put(`${baseUrl}/${payload.id}`, { user: payload.user })
      .then((data) => data.data);
  },
  updateUserCguAcceptedAt({ commit }, payload: { id: number, invitationBy: string }) {
    return axiosInstance.put(`${baseUrl}/${payload.id}/update-cgu`, { invitationBy: payload.invitationBy })
      .then((data) => data.data);
  },
  validate({ commit }, payload: { id: any, token: object }) {
    return axiosInstance.post(`${baseUrl}/${payload.id}/validate`, { token: payload.token })
      .then((data) => data);
  },
  savePreference({ commit }, payload: { id: any, preference: object }) {
    return axiosInstance.put(`${baseUrl}/${payload.id}/preference`, { preference: payload.preference })
      .then((data) => data);
  },
  async getRelays({ commit }, payload: { userId: number }) {
    const res = await axiosInstance.get(`${baseUrl}/${payload.userId}/relays`)
      .then((data) => data.data);
    store.commit("users/setRelays", res.rows);
  },
  getInfoNotification({ commit }, payload: { id: number, relayId: number }) {
    return axiosInstance.get(`${baseUrl}/${payload.id}/notification-info`, { params: { relayId: payload.relayId } })
      .then((data) => data.data);
  },
  saveInfoNotification({ commit }, payload: { id: number, notification: any, relayId: number }) {
    return axiosInstance.post(`${baseUrl}/${payload.id}/notification-info`, {
      notification: payload.notification, relayId: payload.relayId,
    })
      .then((data) => data.data);
  },
  changeNotification({ commit }, payload: { id: number, notification: boolean }) {
    return axiosInstance.put(`${baseUrl}/${payload.id}/notification`, { notification: payload.notification })
      .then((data) => data.data);
  },
  changeFollowAllKeys({ commit }, payload: {id: number, followAllKeys: boolean }) {
    return axiosInstance.put(`${baseUrl}/${payload.id}/follow-all-keys`, { followAllKeys: payload.followAllKeys })
      .then((data) => data.data);
  },
  addFollowedKeys({ commit }, payload: {
    userId: number,
    keyIds: number[],
  }) {
    return axiosInstance.post(`${baseUrl}/${payload.userId}/follow-keys`, { keyIds: payload.keyIds });
  },
  removeFollowedKeys({ commit }, payload: {
    userId: number,
    keyIds: number[],
  }) {
    return axiosInstance.delete(`${baseUrl}/${payload.userId}/follow-keys`, { data: { keyIds: payload.keyIds }});
  },
  getUserKeyAccess({ commit }, payload: {
    userId: number, search: string,
    page: number, itemsPerPage: number, companyId: number,
  }) {
    return axiosInstance.get(`${baseUrl}/${payload.userId}/key-access`, {
      params: {
        search: payload.search,
        page: payload.page,
        itemsPerPage: payload.itemsPerPage,
        companyId: payload.companyId,
      },
    }).then((data) => data.data);
  },
  getUserCompanies({commit}, payload: {userId: number}) {
    return axiosInstance.get(`${baseUrl}/${payload.userId}/companies`).then((data) => data.data);
  },
  getUserKeyHoldings({ commit }, payload: {
    userId: number,
    companyId: number,
    search: string,
    page: number,
    itemsPerPage: number,
  }) {
    return axiosInstance.get(`${baseUrl}/${payload.userId}/key-holdings`, {
      params: {
        companyId: payload.companyId,
        search: payload.search,
        page: payload.page,
        itemsPerPage: payload.itemsPerPage,
      },
    }).then((data) => data.data);
  },
  getUserNotifications({ commit }, payload: {
    userId: number,
    pagination: any,
  }) {
    return axiosInstance.get(`${baseUrl}/${payload.userId}/notifications`,
      {
        params: payload.pagination,
      }).then((data) => data.data);
  },

  /**
   * Get keys in the user's notifications (for filtering)
   * @param param
   * @param payload
   * @returns
   */
  getUserNotificationKeys({ commit }, payload: {
    userId: number,
    pagination: any,
  }) {
    return axiosInstance.get(`${baseUrl}/${payload.userId}/notifications/keys`,
      {
        params: payload.pagination,
      },
    )
    .then((data) => data.data);
  },
  readUserNotifications({ dispatch }, userId: number ) {
    return axiosInstance.put(`${baseUrl}/${userId}/notifications/read-all`);
  },
  deleteUserNotifications({ dispatch }, userId: number ) {
    return axiosInstance.delete(`${baseUrl}/${userId}/notifications/delete-all`);
  },
};

export default {
  namespaced: true, state, getters, actions, mutations,
};
